package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEach
import kotlinx.coroutines.launch
import one.healthium.onboarding.domain.configs.TransparencyAccessScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.onboarding.ui.components.HighlightItem
import one.healthium.ui.common.utils.toTextStyle
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme
import one.primehealth.analytics.permissions.TrackingPermission


interface TransparencyAccessEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun TransparencyAccessScreen(
    eventDelegate: TransparencyAccessEventDelegate,
    screenConfig: TransparencyAccessScreenConfig,
) {
    UserDataProvider { userState, _ ->
        AppScaffold {
            TransparencyAccessScreenContent(
                screenConfig = screenConfig,
                userState = userState,
                onNextClicked = eventDelegate::onNextClicked,
            )
        }
    }
}

@Composable
internal fun TransparencyAccessScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: TransparencyAccessScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    val scope = rememberCoroutineScope()

    Column(
        modifier = modifier
            .fillMaxSize()
            .statusBarsPadding()
            .navigationBarsPadding()
            .padding(horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppText(
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.header,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.weight(1f))
        AppText(
            modifier = Modifier.fillMaxWidth(),
            text = screenConfig.benefitsTitle?.bindPlaceholderValues(userState),
            style = screenConfig.benefitsTitleLabel.toTextStyle(AppTheme.textStyles.subTitleSemiBold),
        )
        Spacer(Modifier.height(24.dp))
        screenConfig.items.fastForEach { highlightItem ->
            HighlightItem(
                text = highlightItem.text.bindPlaceholderValues(userState),
                emoji = highlightItem.emoji.value(userState.gender),
                emojiHeight = screenConfig.emojiHeight ?: 40,
                textStyle = screenConfig.textLabel
            )
        }
        Spacer(Modifier.weight(1f))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 14.dp),
            text = screenConfig.ctaTitle,
            onClick = {
                scope.launch {
                    TrackingPermission.requestTrackingAuthorization()
                    onNextClicked()
                }
            },
        )
        Spacer(Modifier.height(24.dp))
    }
}
